module.exports = __webpack_public_path__ + "img/org-light.d4491e86.svg";